import {cobraApi, utils} from '../framework';

const state = {
  employerId: null,
  defaultCoverageEndRule: null,
  invoiceLetterType: null,
  stateContinuation: false,
  statesToAdminister: null,
  isDB: false,
  autoElectDB: false,
  numberOfInsured: null,
};

const getters = {};

const actions = {
  async load({ commit, rootState, state, dispatch }, data) {
    let id = rootState.employer.employerId;
    if (!id || (data && data.employerId && data.employerId == state.employerId)) return;

    if (!rootState.employer.usesOurCobra) {
      commit('clear');
      return;
    }

    let cobraData = await cobraApi.get(`/employer/${id}`);

    if (!cobraData) {
      commit('clear');
      return;
    }

      commit('set', cobraData);
  },
  async update({ commit, dispatch, rootState, state }, data) {
    let id = rootState.employer.employerId;
    if (!id) return;

    await cobraApi.put(`/employer/${id}`, data);

    dispatch('load');
  },
};

const mutations = {
  clear(state) {
      utils.resetStoreStateProperties(state);
  },
  set(state, data) {
      utils.copyCommonProperties(data, state);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/employer/x-employer-cobra.js